export default function BCPSuccessionPlanningController(
  $q,
  $rootScope,
  $scope,
  alerts,
  bcpDataService,
  bcpSharedModelService,
  confirmDialog,
  editProcessSuccessionDialog,
  loaderService,
  ssDialogService,
  userService,
  emDataService
) {
  const vm = this;

  vm.canExpand = true;
  vm.hasData = false;
  vm.successorOptions = null;
  vm.handleExpand = _handleExpand;
  vm.handleEdit = _handleEdit;
  vm.loadProcesses = _loadProcesses;
  // eslint-disable-next-line max-len
  vm.bcpSuccessionPlanningToolTip = 'Succession Planning is defined in Enterprise Modeling. To make the edits to this section, please navigate to the Process in Enterprise Modeling and select the edit icon.';

  _activate();

  /** **************************************************
   * Event Handlers
   */

  function _handleExpand() {
    if (!vm.hasData) {
      return _loadProcesses();
    }
    return Promise.resolve();
  }

  function _handleEdit($event, process) {
    loaderService.showViewLoader = true;
    emDataService.getSuccessorOptions(process.processId).then((successorResponse) => {
      emDataService.getProcess(process.processId).then((processResponse) => {
        ssDialogService.dialogs.bcp.editProcessSuccessionDialog = ssDialogService.alert(
          editProcessSuccessionDialog.getOptions($event, {
            assessmentId: vm.assessmentId,
            departmentId: processResponse.data.departmentId,
            process,
            successorOptions: successorResponse,
          })
        );
        ssDialogService.show(ssDialogService.dialogs.bcp.editProcessSuccessionDialog);
      });
    });
  }

  /** **************************************************
   * Private Functions
   */

  function _activate() {
    $scope.$on('refreshSuccessionPlanProcesses', _loadProcesses);
    $scope.$on('refreshStatusesComplete', (event, status) => { _initStatus(status); });
    $scope.$on('refreshUsers', () => {
      _loadProcesses();
      _loadSuccessorOptions();
    });
    loaderService.showViewLoader = true;
    userService.getUserPermissionSet('bcp').then((permissions) => {
      loaderService.showViewLoader = false;
      vm.permissions = permissions;
    });
    _initStatus(vm.status);
  }

  function _initStatus(status) {
    vm.status = status;
    if (vm.status.successionPlanningStatus !== 'Succession Planning Complete'
      && vm.status.successionPlanningStatus !== 'Succession Planning Not Started') {
      const successionPlanningStatusArray = vm.status.successionPlanningStatus.split('/');
      vm.completedSuccessionPlanningCount = parseInt(successionPlanningStatusArray[0], 10);
      vm.processCount = parseInt(successionPlanningStatusArray[1].split(' ')[0], 10);
    }

    if (vm.completedSuccessionPlanningCount === vm.processCount
      || vm.status.successionPlanningStatus === 'Succession Planning Complete') {
      vm.statusClass = 'fc-hula-skirt-green-100';
    } else if (vm.completedSuccessionPlanningCount === 0) {
      vm.statusClass = 'fc-navanta-charcoal-55';
    } else if (vm.completedSuccessionPlanningCount !== vm.processCount && vm.completedSuccessionPlanningCount !== 0) {
      vm.statusClass = 'fc-navanta-yellow-100';
    }
  }

  function _loadProcesses() {
    loaderService.showViewLoader = true;
    return bcpSharedModelService.getSuccessionProcesses(vm.assessmentId).then((processes) => {
      loaderService.showViewLoader = false;
      vm.processes = processes;
      vm.hasData = true;
    })
      .catch(() => {
        loaderService.showViewLoader = false;
        alerts.error('An error occurred while fetching the Succession Plan.');
      });
  }

  function _loadSuccessorOptions() {
    vm.successorOptions = null;
  }
}

BCPSuccessionPlanningController.$inject = [
  '$q',
  '$rootScope',
  '$scope',
  'alerts',
  'bcpDataService',
  'bcpSharedModelService',
  'confirmDialog',
  'editProcessSuccessionDialog',
  'loaderService',
  'ssDialogService',
  'userService',
  'emDataService'
];
